
import { i18nText } from '@/locales';

import {Component, Vue} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import AppSimpleLink from "@/UI/components/Link/AppSimpleLink.vue";
import {mixins} from "vue-class-component";

import {ProxyDataForm} from "@/UI/components/Helpers/ProxyDataForm";
import {ProductsMix} from "@/UI/mixins/Store/ProductsMix";
import {ProductsTableMix} from "@/UI/mixins/Store/ProductsTableMix";
import {ProductsCategoriesMix} from "@/UI/mixins/Store/ProductsCategoriesMix";
import {ProductsCategoriesStore} from "@/store/modules/Warehouse/ProductsCategories";
import {ProductsCategoriesTableMix} from "@/UI/mixins/Store/ProductsCategoriesTableMix";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import {WarehouseSupport} from "@/store/modules/Warehouse/Support/current";
import {
  IProductsCategoryTypes,
  ProductsCategoryUpdateRequestType,
} from "@/entity/warehouse/Products/Category/Category.types";

import {Button, Menu, List, Table, Select, Row} from "ant-design-vue";
import {RouterNameEnum} from "@/router/router.types";

import {
  CategoryFormData,
  CategoryFormRules,
  CategorySelectRules,
  CategorySelectForm,
} from "@/form/Warehouse/Category/Category";
import {appFiltersStore} from "@/store/modules/appFilters";
import {RouterProperties} from "@/router/routerProperties";
import {checkUserRole, getUserData} from "@/router/Lib/helper";
import {FormModel} from "ant-design-vue/types/form-model/form";
import {showNotification} from "@/UI/lib/messages";

@Component({
  components: {
    "a-button": Button,
    "a-menu-item": Menu.Item,
    "a-list-item": List.Item,
    "a-list-item-meta": List.Item.Meta,
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-table": Table,
    "a-row": Row,

    PageTitle,
    BaseDataForm,
    AppSimpleLink,
  },
})
export default class Products extends mixins(
    ProxyDataForm,
    ProductsCategoriesTableMix,
    ProductsCategoriesMix,
    ProductsMix,
    ProductsTableMix,
) {
  dataCategories = ProductsCategoriesStore.dataCategories;
  RouteNameE = RouterNameEnum;

  canArchived = false;
  showModal = false;

  showCategorySelectModal = false;

  categoryEditMode = 0;
  StoreId = this.$route.params.Store;
  categoryId = 0;
  loading = true;
  modalTitle = "";

  form = new CategoryFormData();
  categoryForm = new CategorySelectForm();

  rules = CategoryFormRules;
  categoryRules = CategorySelectRules;

  Category = ProductsCategoriesStore.dataCategory;
  Categories = ProductsCategoriesStore.dataCategories;
  Studio_Id = this.$store.state.salon_id;
  category_id = 0;
  search = ''

  Wcd = WarehouseSupport;


  onSearch(): void {
    console.log('eeeee -')
  }

  confirm(e: string): any {
    console.log(e);
    this.$message.success("Click on Yes");
  }

  cancel(e: string): any {
    console.log(e);
    this.$message.error("Click on No");
  }

  createProduct(): void {
    try {
      this.showCategorySelectModal = false;
      this.$router.push({
        name: this.$routeRules.StoresProductsCreate,
        params: {
          fromCategory: String(0),
        },
      });
    } catch (e) {
      console.log("Error create product");
    }
    //this.showCategorySelectModal = true;
  }

  get category(): IProductsCategoryTypes | null {
    return ProductsCategoriesStore.dataCategory;
  }

  onCategorySubmit(): void {
    (this.$refs.categorySelectForm as FormModel).validate((valid) => {
      if (valid) {
        try {
          this.showCategorySelectModal = false;
          this.$router.push({
            name: this.$routeRules.StoresProductsCreate,
            params: {
              fromCategory: String(this.categoryForm.id),
              Studio: this.Studio_Id,
              Store: this.StoreId,
            },
          });
        } catch (e) {
          console.log("Error create product");
        }
      }
    });

    /*this.router.push({
    name: this.$routeRules.StoresProductsCreate,
    params: { fromCategory: '1', Studio: this.Studio_Id, Store: this.StoreId },
});*/
  }

  handleCategoryCancel(): void {
    this.showCategorySelectModal = false;
  }

  async onSubmit(): Promise<void> {
    try {
      if (this.categoryEditMode === 0) {
        try {
          if (checkUserRole() == "owner") {
            const userData = getUserData();
            this.form.salon_id = userData.studios;
          } else if (this.$store.state.salon_id) {
            this.form.salon_id = this.$store.state.salon_id;
          }

          await ProductsCategoriesStore.create(this.form).then((response) => {
            showNotification(i18nText("Категория создана"), response);

            ProductsCategoriesStore.fetchAll({filter: {parent_id: 0}});
            ProductsCategoriesStore.fetchCategories();
          });
        } catch (e) {
          console.log("Error create products categories");
        }
        //this.$message.info("Категория успешно создана!");
      }
      if (this.categoryEditMode === 1) {
        const formData: ProductsCategoryUpdateRequestType = this.form;
        await ProductsCategoriesStore.update(formData);
        await ProductsCategoriesStore.fetchAll({filter: {parent_id: 0}});
        ProductsCategoriesStore.fetchCategories();
        this.$message.info(i18nText("Категория успешно обновлена!"));
      }
    } catch (e) {
      console.log("Error save data -" + e);
    }
    this.showModal = false;
  }

  handleCancel(): void {
    this.showModal = false;
  }

  onDelete(): void {
    ProductsCategoriesStore.delete(this.categoryId).then((response) => {
      showNotification(i18nText("Категория удалена"), response);
    });

    //console.log("Deleteee");
  }

  async editCategory(id: number): Promise<void> {
    await ProductsCategoriesStore.fetchData({filter: {id: id}}).then((data) => {
      if (this.category !== null) this.form.setFormData(this.category);
    });
    this.modalTitle = i18nText("изменить");
    //
    this.categoryEditMode = 1;
    this.categoryId = id;

    this.showModal = true;
    this.loading = false;
  }

  addCategory(): void {
    this.form = new CategoryFormData();
    this.modalTitle = i18nText("Создать категорию");
    this.categoryEditMode = 0;

    this.showModal = true;
    this.loading = false;
  }

  handleUpdateModal(visible: boolean): void {
    this.showModal = visible;
  }

  rowOnChange(selectedRowKeys: any, selectedRows: any): void {
    this.canArchived = selectedRowKeys.length > 0;
    console.log(selectedRowKeys);
  }

  async created(): Promise<void> {
    this.tableLoad = false;
    try {
      //await ProductsStore.fetchAll({ limit: this.AppPageParams.pageSize, filter: { archived: false } })

      await appFiltersStore.setFiltersSource({
        source: RouterProperties.products,
        data: {store_id: this.StoreId},
      });

      let salon_id = 0;

      if (checkUserRole() == "owner") {
        const userData = getUserData();
        salon_id = userData.studios;
      } else if (this.$store.state.salon_id) {
        salon_id = this.$store.state.salon_id;
      }

      await ProductsCategoriesStore.fetchAll({filter: {parent_id: 0, salon_id: salon_id}});

      ProductsCategoriesStore.fetchCategories();
      this.dataCategories.forEach((data, index: number) => {
        if (index === 0) {
          console.log("установка id категории по умолчанию");
          this.Wcd.setDefaultCategory(data.index);
        }
      });
      this.formReady = true;
      this.tableLoad = true;
    } catch (e) {
      console.log(e.message);
      console.log(" Error parsing product Data");
    }
  }
}
